// routeConfig.ts
import { lazy } from 'react';
import { MainLayout } from '../Layout';

const Home = lazy(() => import('../features/Home/Home'));
const Login = lazy(() => import('../features/auth/Login'));
const Manufacturer = lazy(() => import('../features/manufacturer'));
const weightUnit = lazy(() => import('../features/weightUnit'));
const category = lazy(() => import('../features/category/Category'));
const product = lazy(() => import('../features/product'));
const report = lazy(() => import('../features/report'));
const OrderComposer = lazy(() => import('../features/order/OrderComposer'));
const Order = lazy(() => import('../features/order/Order'));
const customer = lazy(() => import('../features/customer'));

export interface RouteItem {
  path: string;
  component?: React.LazyExoticComponent<React.ComponentType<any>>;
  isPrivate?: boolean;
  layout?: React.ComponentType<any>;
  children?: RouteItem[];
  isPublic?: boolean;
}

const routes: RouteItem[] = [
  {
    path: '/login',
    component: Login,
    isPublic: true,
  },
  {
    path: '/',
    isPrivate: true,
    layout: MainLayout,
    component: Home,
  },
  {
    path: '/sales',
    isPrivate: true,
    component: OrderComposer,
  },
  {
    path: '/dashboard',
    isPrivate: true,
    layout: MainLayout,
    children: [
      {
        path: '', // default route under '/dashboard'
        component: Home,
      },
      {
        path: 'manufacturers',
        component: Manufacturer,
      },
      {
        path: 'weight-units',
        component: weightUnit,
      },
      {
        path: 'categories',
        component: category,
      },
      {
        path: 'products',
        component: product,
      },
      {
        path: 'reports',
        component: report,
      },
      {
        path: 'sales',
        component: Order,
      },
      {
        path: 'customers',
        component: customer,
      },
    ],
  },
  // ... other routes
];

export default routes;
